import { apiGet, apiSend } from './client';

export type PlayCurrency = 'AZN' | 'RUB' | 'EUR' | 'USD';

export interface PlayerPreferences {
  play_currency: PlayCurrency;
  payment_region: string;
  locale: string;
  suggested_play_currency: string;
  bank_methods_allowed: boolean;
  open_play_sessions: number;
  can_change_play_currency: boolean;
}

export interface PlayCurrencyOption {
  code: PlayCurrency;
  symbol: string;
  name: string;
}

export interface PaymentRegionOption {
  code: string;
  name: string;
}

export interface FxRatesView {
  base: string;
  play_currencies: string[];
  rates_azn_per_unit: Record<string, string>;
  source: string | null;
  as_of: string | null;
  fetched_at: string | null;
  stale: boolean;
  max_age_hours: number;
}

export interface PlayOptions {
  play_currencies: PlayCurrencyOption[];
  payment_regions: PaymentRegionOption[];
  fx: FxRatesView;
  preferences: PlayerPreferences | null;
}

export function fetchPlayOptions() {
  return apiGet<PlayOptions>('/api/v1/player/meta/play-options');
}

export function fetchPreferences() {
  return apiGet<PlayerPreferences>('/api/v1/player/preferences');
}

export function savePreferences(body: Partial<Pick<PlayerPreferences, 'play_currency' | 'payment_region' | 'locale'>>) {
  return apiSend<PlayerPreferences>('PUT', '/api/v1/player/preferences', body);
}

export interface CloseIdleSessionsResult {
  closed: number;
  blocked: number;
  remaining_open: number;
  can_change_play_currency: boolean;
}

export function closeIdlePlaySessions(sessionId?: string) {
  return apiSend<CloseIdleSessionsResult>('POST', '/api/v1/player/play-sessions/close-idle', {
    session_id: sessionId || null,
    force_idle: true,
  });
}

export function fetchFxRates(refresh = false) {
  return apiGet<FxRatesView>(`/api/v1/player/fx/rates${refresh ? '?refresh=true' : ''}`);
}
